<div class="chart-container">
    
    <!-- Date Range Filter -->
    <div class="filter-section">
        <div class="filter-group">
            <label for="startMonth" class="form-label">Start Month</label>
            <input type="month" id="startMonth" class="form-control" [(ngModel)]="startMonth" [max]="endMonth">
        </div>

        <div class="filter-group">
            <label for="endMonth" class="form-label">End Month</label>
            <input type="month" id="endMonth" class="form-control" [(ngModel)]="endMonth" [min]="startMonth">
        </div>

        <div class="filter-actions">
            <button type="button" class="btn btn-primary" (click)="onFilterApply()">
                <i class="bi bi-search"></i> Apply Filter
            </button>
            <button type="button" class="btn btn-secondary" (click)="onFilterReset()">
                <i class="bi bi-arrow-clockwise"></i> Reset
            </button>
        </div>
    </div>

    @if (error) {
    <div class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ error }}
    </div>
    }

    <!-- Chart -->
    <div class="chart-wrapper">
        <canvas #chartCanvas></canvas>
    </div>

    <!-- Summary Cards -->
    @if (summary && !error) {
    <div class="summary-cards">
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-building"></i> Total Clients
                </h6>
                <p class="card-title value mb-0">{{ summary.totalApprovedClients }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-graph-up"></i> Average Monthly
                </h6>
                <p class="card-title value mb-0">{{ summary.avgMonthlyOnboarding | number:'1.0-1' }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-calendar-check"></i> Latest Onboarding
                </h6>
                <p class="card-title value mb-0">{{ summary.latestOnboarding | date: 'MMM d, y' }}</p>
            </div>
        </div>
    </div>
    }
</div>